import BaseItemView from 'app/src/views/base/BaseItemView';
import Localize from 'app/src/localize/Localize';
import paymentTerminalModalTemplate from './templates/payment-terminal-modal-view.hbs';

const _Events = {
  CANCEL_BUTTON_CLICKED: 'cancel:button:clicked',
  NOT_RESPONDING_CLICKED: 'not:responding:clicked',
};

// configure
let View = BaseItemView.extend({
  template: paymentTerminalModalTemplate,

  ui: {
    cancelButton: '.modal-button',
    paymentInProgress: '.js-payment-in-progress',
    paymentCancel: '.js-payment-cancel',
    paymentNotResponding: '.js-payment-not-responding',
    paymentNoReceipt: '.js-payment-not-responding-wo-receipt',
    paymentWithReceipt: '.js-payment-not-responding-with-receipt',
    paymentWithDeclinedReceipt: '.js-payment-not-responding-with-receipt-declined',
    paymentWithApprovedReceipt: '.js-payment-not-responding-with-receipt-approved',
    message: '#in_progress_message',
    notResponding: '.modal-internal-link',
    transactionID: '.js-transaction-id',
    saleID: '.js-sale-id',
  },

  triggers: {
    'click @ui.cancelButton': _Events.CANCEL_BUTTON_CLICKED,
    'click @ui.notResponding': _Events.NOT_RESPONDING_CLICKED,
  },
});

// define
export default class PaymentTerminalModalView extends View {
  static Event() {
    return _Events;
  }

  /**
   * Enables/disables the cancel transaction button
   *
   * @param enabled {boolean} When true the button is enabled
   */
  enableCancelTransactionButton(enabled) {
    this.ui.cancelButton.prop('disabled', !enabled);

    if (enabled) {
      this.ui.cancelButton.text(Localize.translate('Cancel'));
    } else {
      this.ui.cancelButton.text(Localize.translate('Cancelling...'));
    }
  }

  /**
   * Sets the message displayed in the modal
   *
   * @param {string} message  The message to display
   */
  setMessage(message) {
    this.ui.message.text(message);
  }

  /**
   * Sets the transaction ID in the modal
   *
   * @param {string} transactionID    The transaction ID to display
   */
  setTransactionID(transactionID) {
    this.ui.transactionID.text(transactionID);
  }

  /**
   * Sets the sale ID in the modal
   *
   * @param {string} saleID   The transaction ID to display
   */
  setSaleID(saleID) {
    this.ui.saleID.text(saleID);
  }

  /**
   * Shows the payment in progress content for the modal
   */
  showPaymentInProgress() {
    this._hideAllContent();

    this.ui.paymentInProgress.removeClass('modal-page-hidden');
  }

  /**
   * Shows the cancel message for terminals that do not support cancellation from the POS.
   */
  showCancelDetails() {
    this._hideAllContent();

    this.ui.paymentCancel.removeClass('modal-page-hidden');
  }

  /**
   * Shows the not responding modal
   */
  showNotRespondingModal() {
    this._hideAllContent();

    this.ui.paymentNotResponding.removeClass('modal-page-hidden');
  }

  /**
   * Shows the modal that provides helpful information if the user did got a receipt printed
   */
  showNoReceiptModal() {
    this._hideAllContent();

    this.ui.paymentNoReceipt.removeClass('modal-page-hidden');
  }

  /**
   * Shows the modal that provides a prompt for if the printed receipt was declined or approved
   */
  showWithReceiptModal() {
    this._hideAllContent();

    this.ui.paymentWithReceipt.removeClass('modal-page-hidden');
  }

  /**
   * Shows the modal that provides details on how to handle a case where the payment was declined
   */
  showWithDeclinedReceiptModal() {
    this._hideAllContent();

    this.ui.paymentWithDeclinedReceipt.removeClass('modal-page-hidden');
  }

  /**
   * Shows the modal that provides details on how to handle a case where the payment was approved
   */
  showWithApprovedReceiptModal() {
    this._hideAllContent();

    this.ui.paymentWithApprovedReceipt.removeClass('modal-page-hidden');
  }

  /**
   * Hides all modal content
   *
   * @private
   */
  _hideAllContent() {
    this.ui.paymentInProgress.addClass('modal-page-hidden');
    this.ui.paymentCancel.addClass('modal-page-hidden');
    this.ui.paymentNotResponding.addClass('modal-page-hidden');
    this.ui.paymentNoReceipt.addClass('modal-page-hidden');
    this.ui.paymentWithReceipt.addClass('modal-page-hidden');
    this.ui.paymentWithDeclinedReceipt.addClass('modal-page-hidden');
    this.ui.paymentWithApprovedReceipt.addClass('modal-page-hidden');
  }
}
